import { makeAutoObservable } from 'mobx';

export default class ProjectsListViewModel {}
